import { render } from "./ServicePrograms.vue?vue&type=template&id=0086968a"
import script from "./ServicePrograms.vue?vue&type=script&lang=js"
export * from "./ServicePrograms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__